import React from "react";
import { NavLink } from "react-router-dom";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

type componentProps = {
	link: string;
	img?: any;
	title?: string;
};

export default (props: componentProps) => {
	const { link, img, title } = props;

	return (
		<Card
			sx={{
				maxWidth: 300,
				margin: "1rem 0",
				"& a": {
					color: "inherit",
					textDecoration: "none",
				},
				height: "fit-content",
			}}
		>
			<NavLink to={link}>
				<CardActionArea
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					{img}
					<CardContent>
						<Typography gutterBottom variant="h5" component="div">
							{title}
						</Typography>
					</CardContent>
				</CardActionArea>
			</NavLink>
		</Card>
	);
};
